import { Injectable } from "@angular/core";
import { UsersService } from "@api/users/users.service";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { NzMessageService } from "ng-zorro-antd/message";
import { filter, first, map, mergeMap, switchMap, tap } from "rxjs";
import { AuthApiActions } from "./auth.actions";
import { isAuthenticated } from "./auth.selectors";

@Injectable()
export class AuthEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store,
    private readonly usersRestService: UsersService,
    private readonly notificationService: NzMessageService
  ) {}

  userAuthenticationRestore$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthApiActions.userAuthenticationRestore),
      switchMap(() => this.store.select(isAuthenticated).pipe(first())),
      filter(Boolean),
      map(() => AuthApiActions.userFetchProfile({}))
    )
  );

  userAuthenticationSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthApiActions.userAuthenticationSuccess),
      map(() => AuthApiActions.userFetchProfile({}))
    )
  );

  fetchUserProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthApiActions.userFetchProfile),
      mergeMap(() =>
        this.usersRestService
          .getUserProfile()
          .pipe(
            map((profile) =>
              AuthApiActions.userFetchProfileSuccess({ profile })
            )
          )
      )
    )
  );

  userAuthenticationExpired$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthApiActions.userAuthenticationExpired),
        tap(() =>
          this.notificationService.error(
            "Autoryzacja wygasła. Zaloguj się ponownie."
          )
        )
      ),
    { dispatch: false }
  );
}
